import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { FaBars } from "react-icons/fa";
import './MegaNavbar.css'; // Import custom CSS
// import logo from "../assets/logo11.png"

function TestNavbar() {
  const [expanded, setExpanded] = useState(false); // State to handle navbar expand

  return (
    <div className='header'>
    <div className="main-container main_nav"> {/* Main container */}
      <Navbar  expand="lg" expanded={expanded} className="custom-navbar">
        <Container>
          {/* ORIC Logo */}
          <h2 className='oric_logo'> ORIC</h2>
          {/* <Navbar.Brand href="#home">
          
        

          {/* Custom Toggle Button for Mobile */}
          <FaBars 
            className="custom-toggler" 
            onClick={() => setExpanded(expanded ? false : "expanded")} 
          />

          {/* Navbar Links */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto"> {/* Align right */}
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/MOUs">MOUs</Nav.Link>
              <Nav.Link href="/Projectawarded">Projects Awarded</Nav.Link>
              <Nav.Link href="/Conferences">Conferences</Nav.Link>
              <Nav.Link href="/Downloads">Downloads</Nav.Link>
              <Nav.Link href="/Gallery">Gallery</Nav.Link>
              
              

              {/* Departments Dropdown */}
              <NavDropdown title="Departments" id="basic-nav-dropdown">
                <NavDropdown.Item href="/FacultyofSciences">Faculty of Sciences</NavDropdown.Item>
                <NavDropdown.Item href="/Facultyofsocialscience">Faculty of Social Sciences</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Additional content can be added here within the main container */}
    </div>
    </div>
  );
}

export default TestNavbar;
